import { render, staticRenderFns } from "./RubricCriteriaExpandButton.vue?vue&type=template&id=7e3bdde9&scoped=true&"
import script from "./RubricCriteriaExpandButton.vue?vue&type=script&lang=js&"
export * from "./RubricCriteriaExpandButton.vue?vue&type=script&lang=js&"
import style0 from "./RubricCriteriaExpandButton.vue?vue&type=style&index=0&id=7e3bdde9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e3bdde9",
  null
  
)

export default component.exports